
import React, { useEffect, useState } from 'react';
function EirCustomiseBroadbandOfferDetailTile(props) {

    const renderContent = (content) => {
        return { __html: content };
    }
    const [displayOffers, setDisplayOffers] = useState(false);
    useEffect(() => {
        const broadbandBundleOffers = async () => {
        try{
        let bundles = [];
        let tacticalOffers = await fetch('/json/tactical-offers/tactical-offers.json');
        let response=await tacticalOffers.json()
        bundles=response.bundles;
        setTimeout(() => {
            let getBundleCode;
            let getCookieParams = document.cookie.split(";")
            // let getBundleDetails = JSON.parse(localStorage.getItem("bundleDetails"));
            for (var j = 0; j < getCookieParams.length; j++) {
                if (getCookieParams[j].indexOf("eir_clicked_bundle_code") > 0) {
                    getBundleCode = getCookieParams[j].split("=")[1]
                }
                if (getBundleCode == undefined) {
                    getBundleCode = localStorage.getItem('eir_clicked_bundle_code_from_prequal');   // for recommended bundles
                }
            }
            localStorage.removeItem('bundleOffers');
            var bundleOffers = [];
            let offerDetailsFromLS = "";
            for (var i = 0; i < bundles.length; i++) {
                let bundle_offer_id = bundles[i].bundle_offer_id;
                /*********  check and set offers for the selected bundle code     *********/
                if (bundles[i].bundle_offer_id === getBundleCode && bundles[i][bundle_offer_id].offers.length > 0) {
                    for (var j = 0; j < bundles[i][bundle_offer_id].offers.length; j++) {
                        setDisplayOffers(true);
                        if (bundles[i][bundle_offer_id].offers[j].offer_name) {
                            bundleOffers.push({ OfferDescription: bundles[i][bundle_offer_id].offers[j].offer_name })
                        }
                        if (bundles[i][bundle_offer_id].offers[j].offer_image_path != undefined) {
                            offerDetailsFromLS += "<div class='offerDetailTile mr-3'> <div class='offerTileCard mr-1'><div class='business-general-tile mb-3'><div class='business-general-tile-body'>";
                            offerDetailsFromLS += "<div><div class='p-0'>";
                            offerDetailsFromLS += "<div class=''>";
                            offerDetailsFromLS += "<img class='w-100 mb-2 top-borders' src='" + bundles[i][bundle_offer_id].offers[j].offer_image_path + "' alt='" + bundles[i][bundle_offer_id].offers[j].alt_text + "' /> ";
                            offerDetailsFromLS += "<div class='mb-0 pt-2 pb-0 ml-2  mr-2 offerTileCopy'>"
                            offerDetailsFromLS += "<p class='offer_heading' >" + bundles[i][bundle_offer_id].offers[j].offer_heading + "</p>\n";
                            offerDetailsFromLS += "<p class='offer_copy' >" + bundles[i][bundle_offer_id].offers[j].offer_copy + "</p></div>";
                            offerDetailsFromLS += "</div></div></div></div></div></div></div>"
                        }
                    }
                    localStorage.setItem('bundleOffers', JSON.stringify(bundleOffers));
                } else {
                    console.log("no offers for the selected bundle");
                }
            }            
            document.querySelector(".printOfferDetails").innerHTML = offerDetailsFromLS;
        }, 2000);
        }
    catch(error)
    {
        console.log("Error in displaying offers");
    }

        }
    broadbandBundleOffers();

    }, []);

    return (
        <div>
            <div className="mobileTiles">
                <div className="printOfferDetails d-inline-flex mob-col"></div>
            </div>
        </div>

    )
}
export default EirCustomiseBroadbandOfferDetailTile;